export const INCH_TO_PX = 72;
export const tempSvgUrl =
    'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20100%20100%22%20width%3D%2240%22%20height%3D%2240%22%3E%3Ccircle%20cx%3D%2250%22%20cy%3D%2250%22%20r%3D%2220%22%20stroke%3D%22%23f46147%22%20stroke-width%3D%224%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20%20%20%20stroke-dasharray%3D%2231.4%2031.4%22%20stroke-dashoffset%3D%220%22%3E%3Canimate%20attributeName%3D%22stroke-dashoffset%22%20values%3D%2231.4%3B0%22%20dur%3D%221.5s%22%20repeatCount%3D%22indefinite%22%2F%3E%3CanimateTransform%20attributeName%3D%22transform%22%20type%3D%22rotate%22%20from%3D%220%2050%2050%22%20to%3D%22360%2050%2050%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%2F%3E%3C%2Fcircle%3E%3C%2Fsvg%3E';
export const MAX_CONCURRENT_TASKS = 3;
export const ApiQueries = {
    allProjectsQuery: 'projects',
    selectPagesQuery: 'pages=',
    createProjectQuery: 'projects?pages=',
    projectQuery: 'project',
    detectPointQuery: 'detect-point',
    detectAnnotationQuery: 'detect-point-file',
    usersQuery: 'users',
};
export const DEFAULT_PAGE_SCALE = 0.25;
export const ScaleSource = Object.freeze({
    EXTRACTED: 'EXTRACTED',
    MANUAL: 'MANUAL',
    CALIBRATED: 'CALIBRATED',
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED',
});
export const EXTRACT_TEXT_WIDTH_PERCENTAGE = 1;
export const EXTRACT_TEXT_HEIGHT_PERCENTAGE = 1;
export const DEFAULT_SCALEFACTOR = 0.25;
export const SCALEFACTOR_FOR_CONVERSION = 1.5;
export const DEFAULT_INTERNAL_WALL_LENGTH = 24;
export const DEFAULT_INTERNAL_WALL_WIDTH = 2.5;
export const VALID_EMAIL = 'davidp@modularclosets.com';
